// ============================================
// Path: /frontend/src/pages/PrivacyPage.jsx
// Purpose: Privacy Policy page - static content display
// UPDATED: Mobile-first responsive styling applied to match TermsPage
// ============================================

// ========================================
// IMPORTS
// ========================================
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';

// ========================================
// MAIN COMPONENT
// ========================================
export default function PrivacyPage() {
  console.log('🎨 [PrivacyPage] Component mounted');

  // ========================================
  // RENDER
  // ========================================
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow container py-6 sm:py-8 md:py-12 px-4">
        <div className="max-w-4xl mx-auto">
          {/* Page Header */}
          <div className="text-left mb-4 sm:mb-6 md:mb-8">
            <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-1 sm:mb-2">
              Privacy Policy
            </h1>
            <p className="text-xs sm:text-sm md:text-base text-muted-foreground">
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-6 sm:space-y-8">
            {/* Section 1 */}
            <section className="bg-muted/40 rounded-lg p-3 sm:p-4 md:p-6">
              <h2 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 text-foreground">
                1. Information We Collect
              </h2>
              <p className="text-xs sm:text-sm md:text-base text-foreground/80 leading-relaxed">
                We may collect personal identification information from Users in a variety of ways, including, but not limited to, when Users visit our site, register on the site, place an order, and in connection with other activities, services, features or resources we make available on our Site.
              </p>
            </section>

            {/* Section 2 */}
            <section className="bg-muted/40 rounded-lg p-3 sm:p-4 md:p-6">
              <h2 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 text-foreground">
                2. How We Use Collected Information
              </h2>
              <p className="text-xs sm:text-sm md:text-base text-foreground/80 leading-relaxed">
                MotoHome Finder may collect and use Users personal information for the following purposes: To improve customer service, to personalize user experience, and to process payments.
              </p>
            </section>

            {/* Section 3 */}
            <section className="bg-muted/40 rounded-lg p-3 sm:p-4 md:p-6">
              <h2 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 text-foreground">
                3. How We Protect Your Information
              </h2>
              <p className="text-xs sm:text-sm md:text-base text-foreground/80 leading-relaxed">
                We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored on our Site.
              </p>
            </section>

            {/* Section 4 */}
            <section className="bg-muted/40 rounded-lg p-3 sm:p-4 md:p-6">
              <h2 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 text-foreground">
                4. Sharing Your Personal Information
              </h2>
              <p className="text-xs sm:text-sm md:text-base text-foreground/80 leading-relaxed">
                We do not sell, trade, or rent Users personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates and advertisers.
              </p>
            </section>

            {/* Section 5 */}
            <section className="bg-muted/40 rounded-lg p-3 sm:p-4 md:p-6">
              <h2 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 text-foreground">
                5. Changes to This Privacy Policy
              </h2>
              <p className="text-xs sm:text-sm md:text-base text-foreground/80 leading-relaxed">
                MotoHome Finder has the discretion to update this privacy policy at any time. When we do, we will revise the updated date at the bottom of this page. We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect.
              </p>
            </section>
          </div>

          {/* Footer Note */}
          <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-border">
            <p className="text-[10px] sm:text-xs md:text-sm text-muted-foreground text-center">
              If you have any questions about this Privacy Policy, please contact us.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}